const getEnvironment = () => {
  const key = import.meta.env.VITE_API_ENV || ''

  switch (key) {
    case 'master':
    case 'production':
      return 'production'
    case 'playground':
    case 'demo':
      return 'demo'
    case 'staging':
      return 'staging'
    case 'local':
      return 'local'
    default:
      return 'development'
  }
}

const getApiUrl = env => {
  switch (env) {
    case 'production':
      return `https://api.tabeo.co.uk/v1`
    case 'staging':
      return `https://staging.api.tabeo.co.uk/v1`
    case 'demo':
      return `https://demo.api.tabeo.co.uk/v1`
    case 'local':
      return `http://core.tabeo.local/v1`
    default:
      return `https://development.api.tabeo.co.uk/v1`
  }
}

const getLeadsUrl = env => {
  switch (env) {
    case 'production':
      return `https://lead.tabeo.co.uk`
    case 'demo':
      return `https://demo.lead.tabeo.co.uk`
    case 'staging':
      return `https://staging.lead.tabeo.co.uk`
    case 'local':
      return `http://localhost:3333`
    default:
      return `https://development.lead.tabeo.co.uk`
  }
}

const getConsumerAppUrl = env => {
  switch (env) {
    case 'production':
      return `https://app.tabeo.co.uk`
    case 'staging':
      return `https://staging.app.tabeo.co.uk`
    case 'demo':
      return `https://demo.app.tabeo.co.uk`
    case 'local':
      return `https://app.tabeo.local`
    case 'development':
      return 'https://development.app.tabeo.co.uk'
    default:
      return `http://localhost:3001`
  }
}

export function getAppUrlForCountry(app, country) {
  const host = `${app ? `${app}.` : ''}tabeo`

  const domains = {
    nl: '.nl',
    gb: '.co.uk',
    it: '.it',
    fr: '.fr',
  }

  switch (env) {
    case 'production':
      return `https://${host}${domains[country]}`
    case 'demo':
      return `https://demo.${host}${domains[country]}`
    case 'staging':
      return `https://staging.${host}${domains[country]}`
    default:
      return `https://development.${host}${domains[country]}`
  }
}

const env = getEnvironment()

export const getStripeKey = countryCode => {
  const env = getEnvironment()
  const keys = {
    production: {
      gb: 'pk_live_q0Z92g8ypGCZ9TRp1ikYrJPz',
      nl: 'pk_live_q0Z92g8ypGCZ9TRp1ikYrJPz',
      fr: 'pk_live_51JMAZQBGIOYu7H52XkREoh7xQuk2kMZv5EhQ9gdxQYa3NoD4x0H4TVLdnq8E2nLZSccisYVnsC9WanYQyEFX6MVw00k8CoB2Iy',
      it: 'pk_live_51JMAZQBGIOYu7H52XkREoh7xQuk2kMZv5EhQ9gdxQYa3NoD4x0H4TVLdnq8E2nLZSccisYVnsC9WanYQyEFX6MVw00k8CoB2Iy',
    },
    demo: {
      gb: 'pk_test_waNNA0J3yUXiBnsRvjf9Cktt',
      nl: 'pk_test_waNNA0J3yUXiBnsRvjf9Cktt',
      fr: 'pk_test_51JRbpaHF0Yp4cpo6kfd2i22RfCzZ27ZRIbHsjsawUnWqEoxx2kIHGzrgTtMvh6jOHDSXhnw9IKzMCqimttIfX2W900LinBso43',
      it: 'pk_test_51JRbpaHF0Yp4cpo6kfd2i22RfCzZ27ZRIbHsjsawUnWqEoxx2kIHGzrgTtMvh6jOHDSXhnw9IKzMCqimttIfX2W900LinBso43',
    },
    staging: {
      gb: 'pk_test_TOSV7Y0lyJd50zQTbVoKkOXK',
      nl: 'pk_test_TOSV7Y0lyJd50zQTbVoKkOXK',
      fr: 'pk_test_51JMZ8BK2wRc2E4h0hkDi9h9QPIfcQEiyKzJ7i1TU3lYfHOqNGvvpiH5BtkiYcy17ZJsur2Qb1QY3ft9MXql3OUzG00x13yeaem',
      it: 'pk_test_51JMZ8BK2wRc2E4h0hkDi9h9QPIfcQEiyKzJ7i1TU3lYfHOqNGvvpiH5BtkiYcy17ZJsur2Qb1QY3ft9MXql3OUzG00x13yeaem',
    },
    development: {
      gb: 'pk_test_yM1hmY4bq4AOpQatSsDoaAZL',
      nl: 'pk_test_yM1hmY4bq4AOpQatSsDoaAZL',
      fr: 'pk_test_51JMAZQBGIOYu7H523z0bkIm33fEDkGsOzY98t2UwmiZjZpdKxzHp83eQKcMDoF7AIUeMtP6XyPUk3ZeDICahNyer00xnFyfzeV',
      it: 'pk_test_51JMAZQBGIOYu7H523z0bkIm33fEDkGsOzY98t2UwmiZjZpdKxzHp83eQKcMDoF7AIUeMtP6XyPUk3ZeDICahNyer00xnFyfzeV',
    },
    local: {
      gb: 'pk_test_yM1hmY4bq4AOpQatSsDoaAZL',
      nl: 'pk_test_yM1hmY4bq4AOpQatSsDoaAZL',
      fr: 'pk_test_51JMAZQBGIOYu7H523z0bkIm33fEDkGsOzY98t2UwmiZjZpdKxzHp83eQKcMDoF7AIUeMtP6XyPUk3ZeDICahNyer00xnFyfzeV',
      it: 'pk_test_51JMAZQBGIOYu7H523z0bkIm33fEDkGsOzY98t2UwmiZjZpdKxzHp83eQKcMDoF7AIUeMtP6XyPUk3ZeDICahNyer00xnFyfzeV',
    },
  }

  const key = keys[env][countryCode]

  if (!key) {
    throw new Error(`No stripe key for country ${countryCode} on ${env}`)
  }

  return key
}

const getGoCardlessKeys = env => {
  switch (env) {
    case 'production':
      return {
        OF: 'fP_5Et2H9mJ89OhQTLDqLNvItZ4fD_HeUILOqd_C',
        HF: 'kyMcxg3P98fXKwBGxcCNa5I1ecCEgw6Sw2yu-_1i',
        WA: 'icntcJ8wEnPT3yQOHEdRyep9kG6vgSyDTtmZiM0p',
        FO: '8YQcsEidAIwW7IIV7ZS2Cahy4aT2sMIiUAB1kvpf',
        PLANS: 'nqpxwvnaU3134YdnD5ZacmkP_ku7Y4mC6MOTqtf0',
        NP: 'QxE31RGjXpvIWTZ9_IcUOcWavdqQJX7TGzIslvg7',
      }
    case 'demo':
      return {
        OF: 'oIN5Jkhifh8tAEQNa3Bh3Nnbll0f3uMDbOo1mB_7',
        HF: 'fyvAM6QflkOEa7ODHANuSirXeS-wVGNaRZ-E4rjb',
        WA: 'ABrsBztEU_UYfH7cgZ29tMUjmiH5rHs2dmvErhyT',
        FO: 'bs2joqfQL1SBHAjjLJbJm_akDEhGWAiyQEnl4stD',
        PLANS: '5myCcGj8rkF6Ob9RgC-lrWHBIhLkOAsWF6xnh_zF',
        NP: '-G-WgAhk4uXNjk0r-OgSVk_or7P-JN0BWEgEZNRD',
      }
    case 'staging':
      return {
        OF: 'CEPTSmOrrSiaciThbm9Ld2fmZ66C9TNaMZEW7F5_',
        HF: 'PRLYcJn8vjXqA4NjkQLtqqDDpimubibJYmVQuOu4',
        WA: 'Zi8ZidecmYYsvj6pC0xII2gSHL6Kz-0rMPpwah2Z',
        FO: 'Jz3JBRNvThkrp4LaO58Y-zO25RLmrV9sGwmoWgGH',
        PLANS: 'C13aTppI5_xkD10jcUk3KEzRmztSPRuecuPXw8V0',
        NP: 'TmF441lgHwaZvRzc55thOK503KPkICHlB5BpyUPP',
      }
    default:
      return {
        OF: 'DQuEbM8-HiujMhKluOJ8e0DHO0-TT5m0lCqeunY5',
        HF: 'nh06gaYz7VcePLjwDlh6KuGdpfI7msX_Yfir8_fH',
        WA: '9rbahnyxnckEqK1nHHy07YljI0n0aGdjR6IWkmze',
        FO: 'GVfGjEUHFCRlNvdIHphIP1Tzj-jVOG9cQvDcfRpd',
        PLANS: 'C13aTppI5_xkD10jcUk3KEzRmztSPRuecuPXw8V0',
        NP: 'rCykHLjjd1srEHOh-DtrNUFnHHyI1qFHMnEb9prV',
      }
  }
}

const getGoCardlessApiURL = env => {
  switch (env) {
    case 'production':
      return 'https://api.gocardless.com'
    default:
      return 'https://api-sandbox.gocardless.com'
  }
}

const getPcaApiKey = env => {
  const FALLBACK_PCA_KEY = 'UA97-PP22-CG98-HT84'

  switch (env) {
    case 'production':
      return 'DD99-PE44-AT33-BP91'
    case 'staging':
      return `JB29-ZE48-YD34-RF97`
    case 'demo':
      return `UM83-RZ36-UU38-DF46`
    case 'development':
      return FALLBACK_PCA_KEY
    default:
      return FALLBACK_PCA_KEY
  }
}

const config = {
  ENV: env,
  API_URL: getApiUrl(env),
  LEADS_URL: getLeadsUrl(env),
  CONSUMER_APP_URL: getConsumerAppUrl(env),
  PCA_API_KEY: getPcaApiKey(env),
  GOCARDLESS_API_URL: getGoCardlessApiURL(env),
  GOCARDLESS_KEYS: getGoCardlessKeys(env),
  DATO_TOKEN: '1b4bc963d1e778ce632a606df0fa7a',
  LEADS_API_SECRET: 'tabeo321',
  FEATURE_FLAGS: JSON.parse(import.meta.env.VITE_FEATURE_FLAGS || '{}'),
  PLATFORM_API_URL: getAppUrlForCountry('platform-api', 'gb'),
}

export default config
